import angular from 'angular';
import React from 'react';
import ReactDOM from 'react-dom';
import { TagBeta } from '@doxyme/ui';
const component = {
    controller: class {
        constructor($element) {
            this.$element = $element;
        }
        $onInit() {
            ReactDOM.render(React.createElement(TagBeta), this.$element[0]);
        }
        $onDestroy() {
            ReactDOM.unmountComponentAtNode(this.$element[0]);
        }
    },
};
export default angular
    .module('doxy.common.components.betaTag', [])
    .component('betaTag', component).name;
